module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921005649_T.2ce11114.jpg";